// src/components/Celebration.tsx
import React, { useEffect, useState } from 'react';
import { stopSound, playSound } from "../services/soundService";

const EMOJIS = ['🎉', '👏', '🥳', '✨', '💥'];
const COUNT = 30;

type Props = {
  trigger: boolean;
  onComplete?: () => void;
};

const Celebration: React.FC<Props> = ({ trigger, onComplete }) => {
  const [particles, setParticles] = useState<
    { id: number; emoji: string; x: number; y: number }[]
  >([]);

  useEffect(() => {
    stopSound('background');
    playSound('celebration');
  }, []);

  useEffect(() => {
    if (!trigger) return;
    // generate random particles
    const newParticles = Array.from({ length: COUNT }, (_, i) => ({
      id: i,
      emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
      x: Math.random() * 100,
      y: Math.random() * 100,
    }));
    setParticles(newParticles);
    // clear after 2s
    const t = setTimeout(() => {
      setParticles([]);
      onComplete?.();
    }, 2000);
    return () => clearTimeout(t);
  }, [trigger, onComplete]);

  if (!particles.length) return null;

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {particles.map(p => (
        <div
          key={p.id}
          style={{
            position: 'absolute',
            left: `${p.x}%`,
            top: `${p.y}%`,
            animation: 'riseAndFade 2s ease-out forwards',
            fontSize: '24px',
          }}
        >
          {p.emoji}
        </div>
      ))}
      <style>{`
        @keyframes riseAndFade {
          0%   { transform: translateY(0) scale(1); opacity:1; }
          100% { transform: translateY(-50px) scale(0.5); opacity:0; }
        }
      `}</style>
    </div>
  );
};

export default Celebration;
